import { PropsWithChildren, ReactElement, useState } from 'react';

export interface PopUpProps {
  icon: ReactElement;
}

export function PopUp({ icon, children }: PropsWithChildren<PopUpProps>) {
  const [open, setOpen] = useState(false);

  const onBlur = e => {
    if (!e.relatedTarget || e.relatedTarget.nodeName !== 'EM-EMOJI-PICKER') setTimeout(setOpen, 100, false);
  };

  const onFocus = e => {
    e.preventDefault();
    setOpen(true)
  }

  return (
    <div tabIndex={0} onMouseEnter={onFocus} onMouseLeave={onBlur} className={'relative'}>
      <div className={`p-1 rounded ${open ? 'dark:bg-slate-800' : ''}`}>{icon}</div>

      {open && (
        <div className="z-front absolute transform -translate-x-1/2 bg-white dark:bg-slate-900 flex flex-row  border  border-slate-700/40  py-1 px-1 rounded-lg shadow-sm space-x-2">
          {children}
        </div>
      )}
    </div>
  );
}
